import { useEffect, useRef, useState } from 'react';
import { useEmitAPIEvent } from '@elfsight/widget-js-api';
import { useSettings } from '@wu/widget-core';
import { API_INIT_EVENT } from '../constants/custom-js-events';
import { useUserLocation } from '../user-location-context';

export function useInitWidgetAPIEvent() {
  const settings = useSettings();
  const { locations } = useUserLocation();
  const emitAPIEvent = useEmitAPIEvent();
  const [isLoading, setIsLoading] = useState(true);

  const isInitialized = useRef(false);
  const mainContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (locations.length && isLoading) {
      setIsLoading(false);
    }
  }, [locations, isLoading]);

  useEffect(() => {
    if (!isLoading && !isInitialized.current) {
      emitAPIEvent(API_INIT_EVENT, [
        { widgetContainer: mainContainerRef.current, settings }
      ]);
      isInitialized.current = true;
    }

    return () => {
      isInitialized.current = false;
    };
  }, [emitAPIEvent, settings, isLoading]);

  return mainContainerRef;
}
